import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, } from '@mui/material';
import { LoadingButton } from '../../LoadingButton';
import { DialogActions } from '../DialogActions';
export const DialogActionsWithButtons = ({ startContent, sx, CancelButtonProps, DialogActionsProps, SubmitButtonProps, }) => {
    return (_jsxs(DialogActions, { ...DialogActionsProps, sx: {
            display: 'flex',
            flexDirection: {
                xs: 'column',
                md: 'row',
            },
            alignItems: {
                xs: 'stretch',
                md: 'end',
            },
            gap: 2,
            '&>:not(:first-of-type)': { marginLeft: 0 },
            ...sx,
        }, children: [startContent, CancelButtonProps && (_jsx(Button, { variant: "outlined", ...CancelButtonProps, children: CancelButtonProps.buttonText ?? 'Cancel' })), _jsx(LoadingButton, { variant: "contained", ...SubmitButtonProps })] }));
};
